import { useState } from 'react'
import { PasskeyButton } from './PasskeyButton'

interface Props {
  onComplete: () => void
}

export function OnboardingFlow({ onComplete }: Props) {
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  return (
    <div style={{ maxWidth: 480, margin: '4rem auto', padding: '2rem' }}>
      <h1>welcome to abaddon</h1>
      <p>create the first account — it will have sudo access.</p>
      <br />
      {error && <p style={{ color: 'var(--color-1)', marginBottom: '1rem' }}>{error}</p>}
      <label>
        username
        <input value={username} onChange={(e) => setUsername(e.target.value)} />
      </label>
      <br />
      <label>
        email
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <br />
      <PasskeyButton
        username={username}
        email={email}
        mode="register"
        deviceName="primary device"
        onSuccess={onComplete}
        onError={setError}
      />
    </div>
  )
}
